document.addEventListener("click", function (event) {
  const btn = event.target.closest(".line-item__qty-btn");
  if (!btn) return;

  const stepper = btn.closest(".line-item__quantity-stepper");
  if (!stepper) return;

  const input = stepper.querySelector(".quantity-input");
  const display = stepper.querySelector(".line-item__qty-value");
  if (!input) return;

  const change = parseInt(btn.dataset.change, 10);
  const min = parseInt(input.min, 10) || 0;
  const max = btn.dataset.max ? parseInt(btn.dataset.max, 10) : Infinity;
  const current = parseInt(input.value, 10);
  const next = Math.min(Math.max(current + change, min), max);

  if (next === current) return;

  input.value = next;
  if (display) display.textContent = next;

  input.dispatchEvent(new Event("change", { bubbles: true }));
});
